import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .widgets-container-video {
    margin-bottom: 16px;
    border-radius: 12px;
    overflow: hidden;
  }

  .actions-wrapper {
    width: 100%;
    margin-left: 32px;
    display: flex;
    gap: 16px;

    .border-line {
      content: '';
      height: 44px;
      border-right: 1px solid ${(props) => props.theme.colors.outline};
    }

    .alert-validation {
      font-size: 13px;
    }
  }

  .map-wrapper {
    width: 100%;
    min-width: 403px;
  }

  .map-container {
    border-radius: 0 12px 12px 0;
    width: 100%;
    height: 100%;
  }

  .video-container {
    border-radius: 12px;
    display: flex;
    background-color: ${(props) => props.theme.colors.widget_background};
  }

  .map-icon {
    color: ${(props) => props.theme.colors.inactive};
  }
`;

export default { Wrapper };
